/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { ISecurityRequirementParent } from '../../../models/common/ISecurityRequirementParent';
import { SecurityRequirement } from '../../../models/common/SecurityRequirement';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { Node } from '../../../models/Node';

/**
 * Constructor.
 * 
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author cfoskin@redhat.com
 */
export class SecurityRequirementUniquenessValidationRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @param {SecurityRequirement} currentSecurityRequirement
     * @param {SecurityRequirement} otherSecurityRequirement
     * @return {boolean} returns true if the two security requirements are equal
     * @private
     */
    /*private*/ static isEqualTo(currentSecurityRequirement : SecurityRequirement, otherSecurityRequirement : SecurityRequirement) : boolean {
        let currentSecurityRequirementNames : Array<string> = currentSecurityRequirement.getSecurityRequirementNames();
        let otherSecurityRequirementNames : Array<string> = otherSecurityRequirement.getSecurityRequirementNames();
        /* sort */currentSecurityRequirementNames.sort();
        /* sort */otherSecurityRequirementNames.sort();
        if(!/* equals */((a1, a2) => { if(a1==null && a2==null) return true; if(a1==null || a2==null) return false; if(a1.length != a2.length) return false; for(let i = 0; i < a1.length; i++) { if(<any>a1[i] != <any>a2[i]) return false; } return true; })(currentSecurityRequirementNames, otherSecurityRequirementNames)) {
            return false;
        }
        for(let index219=0; index219 < currentSecurityRequirementNames.length; index219++) {
            let secReqName = currentSecurityRequirementNames[index219];
            {
                let secReqScopes : Array<string> = currentSecurityRequirement.getScopes(secReqName);
                let otherSecReqScopes : Array<string> = otherSecurityRequirement.getScopes(secReqName);
                /* sort */secReqScopes.sort();
                /* sort */otherSecReqScopes.sort();
                if(!/* equals */((a1, a2) => { if(a1==null && a2==null) return true; if(a1==null || a2==null) return false; if(a1.length != a2.length) return false; for(let i = 0; i < a1.length; i++) { if(<any>a1[i] != <any>a2[i]) return false; } return true; })(secReqScopes, otherSecReqScopes)) {
                    return false;
                }
            }
        }
        return true;
    }

    /**
     * @param {SecurityRequirement} currentSecurityRequirement
     * @param {SecurityRequirement[]} allRequirements
     * @return {boolean} true if duplicates are found
     * @private
     */
    /*private*/ static checkForDuplicates(currentSecurityRequirement : SecurityRequirement, allRequirements : Array<SecurityRequirement>) : boolean {
        let clonedList : Array<SecurityRequirement> = <any>(allRequirements.slice(0));
        /* remove */(a => { let index = a.indexOf(currentSecurityRequirement); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(clonedList);
        for(let index220=0; index220 < clonedList.length; index220++) {
            let otherSecurityRequirement = clonedList[index220];
            {
                if(SecurityRequirementUniquenessValidationRule.isEqualTo(currentSecurityRequirement, otherSecurityRequirement)) {
                    return true;
                }
            }
        }
        return false;
    }

    /**
     * @param {SecurityRequirement} node
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>node.parent();
        let securityRequirements : Array<SecurityRequirement> = parent.getSecurityRequirements();
        if(/* size */(<number>securityRequirements.length) <= 1) {
            return;
        }
        if(SecurityRequirementUniquenessValidationRule.checkForDuplicates(node, securityRequirements)) {
            this.report(node, Constants.PROP_SECURITY, this.map("securityReq", /* toString */('['+node.getSecurityRequirementNames().join(', ')+']')));
        }
    }
}
SecurityRequirementUniquenessValidationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.other.SecurityRequirementUniquenessValidationRule";
SecurityRequirementUniquenessValidationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




